import { useTranslation } from 'react-i18next'

export const useFilterLabels = () => {
    const { t } = useTranslation('translations')

    return {
        saveLabel: t(`common.apply`),
        resetLabel: t(`common.clear`),
    }
}
